module.exports = __webpack_public_path__ + "img/def-image.63df74b4.svg";